import React from 'react';
import { IContactFilters } from 'src/pages/Contacts/CustomHooks/useContactFilters';
import './activeFilterPills.scss';
import { FilterPill } from 'src/components/FIlterPill/FilterPill';

interface ActiveFilterPillsProps {
  activeFilters: IContactFilters;
  removeSingleActiveFilter: any;
}

const ActiveFilterPills = ({
  activeFilters,
  removeSingleActiveFilter,
}: ActiveFilterPillsProps) => {
  // Don't render anything if no active filters.
  if (!activeFilters || Object.keys(activeFilters).length === 0) {
    return null;
  }

  // Array to collect all filter pill texts.
  const filterPills: string[] = [];

  // Add role filter pills.
  if (activeFilters.roles && activeFilters.roles.length > 0) {
    activeFilters.roles.forEach((role) => {
      filterPills.push(`${role}`);
    });
  }

  // Add property filter pills.
  if (activeFilters.property && activeFilters.property.length > 0) {
    activeFilters.property.forEach((propertyObject) => {
      const propertyName: string = propertyObject.name;
      filterPills.push(`${propertyName}`);
    });
  }

  // Add building filter pill.
  if (
    activeFilters.selectedBuilding &&
    activeFilters.selectedBuilding.length > 0
  ) {
    const buildingName: string = activeFilters.selectedBuilding[0].name;
    filterPills.push(`Building: ${buildingName}`);
  }

  // Add level filter pill.
  if (activeFilters.selectedLevel && activeFilters.selectedLevel.length > 0) {
    const levelName: string = activeFilters.selectedLevel[0].name;
    filterPills.push(`Level: ${levelName}`);
  }

  // Add unit filter pill.
  if (activeFilters.selectedUnit && activeFilters.selectedUnit.length > 0) {
    const unitName: string = activeFilters.selectedUnit[0].name;
    filterPills.push(`Unit: ${unitName}`);
  }

  // Add status filter pills.
  if (activeFilters.status && activeFilters.status.length > 0) {
    activeFilters.status.forEach((status) => {
      filterPills.push(`${status}`);
    });
  }

  // Add email filter pill.
  if (activeFilters.email && activeFilters.email.trim() !== '') {
    filterPills.push(`${activeFilters.email}`);
  }

  // Add phone filter pill.
  if (activeFilters.phone && activeFilters.phone.trim() !== '') {
    filterPills.push(`${activeFilters.phone}`);
  }

  // Add name filter pill.
  if (activeFilters.name && activeFilters.name.trim() !== '') {
    filterPills.push(`${activeFilters.name}`);
  }

  // Add date range filter pills.
  if (activeFilters.dateRange) {
    if (activeFilters.dateRange.startDate) {
      const startDate: string = new Date(
        activeFilters.dateRange.startDate
      ).toLocaleDateString();
      filterPills.push(`${startDate}`);
    }
    if (activeFilters.dateRange.endDate) {
      const endDate: string = new Date(
        activeFilters.dateRange.endDate
      ).toLocaleDateString();
      filterPills.push(`${endDate}`);
    }
  }

  // Add search term filter pill.
  if (activeFilters.searchTerm && activeFilters.searchTerm.trim() !== '') {
    filterPills.push(`${activeFilters.searchTerm}`);
  }

  return (
    <FilterPill
      filters={filterPills}
      onDeleteFilter={removeSingleActiveFilter}
    />
  );
};

export default ActiveFilterPills;
